import { Component, OnInit } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';
import { User } from 'firebase';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-inicio-page',
  templateUrl: './inicio-page.component.html',
  styleUrls: ['./inicio-page.component.css']
})
export class InicioPageComponent implements OnInit {
  user: User = null;
  isAuthenticated = false;
  isLoading = true;

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.getCurrentUser();
  }

  getCurrentUser(): void {
    this.isLoading = true;
    this.authService.getCurrentUser().subscribe((response) => {
      if (response) {
        this.user = response;
        this.isAuthenticated = true;
        this.isLoading = false;
        return;
      }
      this.isLoading = false;
      this.isAuthenticated = false;
    });
  }

  // Función para realizar un scroll a un ID en la vista
  scroll(id) {
    console.log(`scrolling to ${id}`);
    let el = document.getElementById(id);
    el.scrollIntoView({behavior: 'smooth'});
  }

  Futbol: AnimationOptions = {
    path: '/assets/img/futbol.json',
  };

  Cancha: AnimationOptions = {
    path: '/assets/img/cancha.json',
  };

  Celebracion: AnimationOptions = {
    path: '/assets/img/celebracion.json',
  };

  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }
}
